import { PatientRiskGapsV1 } from './patient-risk-gaps-v1';

export const PatientRiskGapsUiSelector = () => {
  return <PatientRiskGapsV1 testId="patient-risk-gaps-v1" />;
};
